/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneDiagIcon20Light = forwardRef('SendPaperplaneDiagIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.254 8.919c-.933-.646-.71-2.083.376-2.416l12.907-3.95a1.358 1.358 0 0 1 1.696 1.697l-3.95 12.907c-.332 1.085-1.77 1.308-2.415.375l-3.523-5.09-5.09-3.523Zm6.1 3.221 3.336 4.823c.17.246.55.187.637-.099l3.95-12.907a.358.358 0 0 0-.447-.447L2.922 7.46a.358.358 0 0 0-.099.636l4.823 3.337 3.106-3.106a.5.5 0 1 1 .707.707L8.353 12.14Z" })));
});
